// extracted by mini-css-extract-plugin
export default {"table":"lm3v2","tr":"Ruj4g","td":"Rp4r9","row":"On2sW","rowTitle":"Zyqkq","rowDescription":"RYxDv","cellTitle":"sNOAB","cellDescription":"DDkHz"};